<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headers"
      :items="prefeituras"
      :items-per-page="8"
      :loading="loading"
      :paginate="true"
      :lastPage="lastPage"
      :currentPage="currentPage"
      @pageChange="fetchBlocks({ ...filter, page: $event })"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="8" lg="8" class="pa-0">
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pa-0">
            <MenuFilterSearchTable
              :placeholder="'Buscar por cidade ou cod. IBGE'"
              :textQuery="'descricao'"
              :codQuery="'cod_ibge'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- ---------------- header ---------------- -->
      <template v-slot:header.schema="{ header }">
        <span>
          {{ header.text }}
          <MenuFilterSelect
            :items="[
              { shema: 'NBS', descricao: 'NBS' },
              { shema: 'CCV', descricao: 'CCV' },
            ]"
            :itemText="'descricao'"
            :itemValue="'shema'"
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.cod_ibge="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.descricao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.uf="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="header.text"
            :query="header.value"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>
      <!-- ---------------- items ---------------- -->
      <template v-slot:item.valr_parametro="{ item }">
        <div class="bg-error d-flex align-center">
          <v-switch
            color="primary"
            v-can:permission="'bloqueio-prefeitura#update'"
            v-model="item.status"
            @click.native.stop="changeBlock(item)"
          />
          <v-icon
            :disabled="!item.status"
            class="mx-1"
            :color="item.status ? 'primary' : 'default'"
            size="25"
          >
            {{
              item.status ? "mdi-lock-outline" : "mdi-lock-open-variant-outline"
            }}
          </v-icon>
        </div>
      </template>
      <template v-slot:item.logs="{ item }">
        <v-btn color="#4ebf53" icon @click="openModal(item.cod_ibge)">
          <v-icon>mdi-file-document</v-icon>
        </v-btn>
      </template>
    </BaseDataTable>
    <ModalLogs
      :dialog.sync="dialog"
      :idPrefeitura="prefeitura"
      @update:dialog="dialog = $event"
    />
  </v-card>
</template>

<script>
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import MenuFilterSelect from "@/components/MenuFilterSelect.vue";
import BloqueioPrefeitura from "@/services/http/rpa/BloqueioPrefeitura.js";
import ModalLogs from "./ModalLogs.vue";

export default {
  components: {
    MenuFilter,
    MenuFilterSelect,
    MenuFilterSearchTable,
    BaseDataTable,
    ModalLogs,
  },

  data() {
    return {
      lastPage: 1,
      currentPage: 1,
      loading: false,
      prefeituras: [],

      idPrefeitura: "",
      prefeitura: "",
      dialog: false,
      filter: {},
      status: { S: true, N: false },
      headers: [
        {
          text: "Schema",
          value: "schema",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "Cód. IBGE",
          value: "cod_ibge",
        },
        {
          text: "Cidade",
          value: "descricao",
          align: "center",
        },
        {
          text: "UF",
          value: "uf",
          align: "center",
        },
        {
          text: "Status",
          value: "valr_parametro",
          align: "center",
        },
        {
          text: "Logs",
          value: "logs",
          align: "center",
        },
      ],
    };
  },
  watch: {
    filter(value) {
      this.fetchBlocks(value);
    },
  },
  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    async fetchBlocks(filters) {
      try {
        this.loading = true;
        let { data } = await BloqueioPrefeitura().show({ ...filters, per_page: 8 });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.prefeituras = data.data.map((item) => {
          return { ...item, status: this.status[item.valr_parametro] };
        });

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    openModal(id) {
      this.dialog = true;
      this.prefeitura = id;
    },

    async changeBlock(item) {
      item.status = !item.status;

      try {
        let text = item.valr_parametro == "N" ? "bloquear" : "desbloquear";

        await this.$swal({
          title: `${text} prefeitura`,
          text: `Deseja ${text} esta prefeitura?`,
          icon: "question",
          showDenyButton: true,
          confirmButtonText: `Sim! ${text}`,
          denyButtonText: "Não, Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await BloqueioPrefeitura().store({
              schema: item.schema,
              cod_ibge: item.cod_ibge,
            });
            item.status = !this.status[item.valr_parametro];
            item.valr_parametro = item.valr_parametro === "S" ? "N" : "S";
            return;
          }
          item.status = this.status[item.valr_parametro];
        });
      } catch (error) {
        item.status = this.status[item.valr_parametro];
        console.log(error);
      }
    },
  },

  created() {
    this.fetchBlocks();
  },
};
</script>

<style scoped>
.bg-error {
  /* background-color: red !important; */
  display: flex;
  justify-content: center;
}
</style>
